import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  visit(event) {
    if (window.matchMedia("(min-width: 1024px)").matches) return
    if (event.target.closest("a, button, input, select, textarea")) return
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    if (window.getSelection().toString()) return

    this.element.querySelector("a").click()
  }
}
